import { CURRENCIES, DEFAULT_CURRENCY } from '../constants/currenciesConstants';
import { numberWithCommas } from './commonHelper';

/**
 * Employee-facing monetary reward label.
 * Prefers backend-provided display_label; otherwise formats locally with optional ISO prefix.
 */
export function formatEmployeeReward(amount, currencyCode = DEFAULT_CURRENCY, { showIsoPrefix = false } = {}) {
  const code = currencyCode || DEFAULT_CURRENCY;
  const symbol = CURRENCIES[code] || '$';
  const formatted = `${symbol}${numberWithCommas(amount)}`;
  if (!showIsoPrefix) return formatted;
  return `${code} ${formatted}`;
}

/** Use API display_label when present; otherwise format from parts. */
export function rewardDisplayLabel({ displayLabel, amount, currencyCode, showIsoPrefix = false } = {}) {
  if (displayLabel) return displayLabel;
  if (amount == null) return null;
  return formatEmployeeReward(amount, currencyCode, { showIsoPrefix });
}
